import { createMenuSlice } from './createMenuSlice';
import { createUserSlice, createUserAuthListSlice } from './createUserSlice';
import { createAuthBtnSlice } from './createAuthBtnSlice';
import { createTabMenuSlice } from './createTabMenuSlice';

export const createAuthSlice = (set) => ({
  setUserAndMenuState: ({
    user,
    menu,
    authBtn,
    hierarchyMenu,
    pageRenderType,
    showTopMenuYn,
    favoriteMenu,
    selectedTopMenu,
    selectedMenu,
    helpMenuYn,
    authList,
  }) => {
    createUserSlice(set).setUserInfo(user);
    createMenuSlice(set).setMenuList(menu);
    createAuthBtnSlice(set).setAuthBtnList(authBtn);
    createMenuSlice(set).setHierarchyMenu(hierarchyMenu);
    createMenuSlice(set).setPageRenderType(pageRenderType);
    if (showTopMenuYn) {
      createMenuSlice(set).setShowTopMenuYn(showTopMenuYn);
    }
    createMenuSlice(set).setFavoriteMenu(favoriteMenu);
    if (selectedTopMenu) {
      createMenuSlice(set).setSelectedTopMenu(selectedTopMenu);
    } else {
      createMenuSlice(set).setSelectedTopMenu({});
    }
    if (selectedMenu) {
      createMenuSlice(set).setSelectedMenu(selectedMenu);
    } else {
      createMenuSlice(set).setSelectedMenu({});
    }
    if (helpMenuYn) {
      createMenuSlice(set).setHelpMenuYn(helpMenuYn);
    } else {
      createMenuSlice(set).setHelpMenuYn({});
    }
    createUserAuthListSlice(set).setAuthList(authList);
  },

  resetUserAndMenuState: () => {
    createUserSlice(set).resetUserInfo();
    createMenuSlice(set).resetMenu();
    createTabMenuSlice(set).resetTabMenuList();
  },
});
